import React from "react";

const IconPriceRange = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M30.8915 28.0163H1.1084C0.496093 28.0163 0 27.5202 0 26.9082V12.7576C0 12.1455 0.496093 11.6492 1.1084 11.6492H30.8918C31.5038 11.6492 31.9999 12.1455 31.9999 12.7576V26.9082C31.9999 27.5202 31.5038 28.0163 30.8915 28.0163Z"
      fill="url(#paint0_linear_716_1810)"
    />
    <path
      d="M0 24.7822V26.9084C0 27.5205 0.496093 28.0166 1.1084 28.0166H30.8918C31.5038 28.0166 31.9999 27.5205 31.9999 26.9084V24.7822H0Z"
      fill="url(#paint1_linear_716_1810)"
    />
    <path
      d="M30.8915 26.559H1.1084C0.496093 26.559 0 26.0627 0 25.4507V11.3003C0 10.688 0.496093 10.1919 1.1084 10.1919H30.8918C31.5038 10.1919 31.9999 10.688 31.9999 11.3003V25.4507C31.9999 26.0627 31.5038 26.559 30.8915 26.559Z"
      fill="url(#paint2_linear_716_1810)"
    />
    <path
      d="M0 23.3242V25.4504C0 26.0625 0.496093 26.5588 1.1084 26.5588H30.8918C31.5038 26.5588 31.9999 26.0625 31.9999 25.4504V23.3242H0Z"
      fill="url(#paint3_linear_716_1810)"
    />
    <path
      d="M30.8915 25.1015H1.1084C0.496093 25.1015 0 24.6054 0 23.9934V9.84277C0 9.23071 0.496093 8.73438 1.1084 8.73438H30.8918C31.5038 8.73438 31.9999 9.23047 31.9999 9.84277V23.9934C31.9999 24.6054 31.5038 25.1015 30.8915 25.1015Z"
      fill="url(#paint4_linear_716_1810)"
    />
    <path
      d="M0 21.8669V23.9932C0 24.6052 0.496093 25.1013 1.1084 25.1013H30.8918C31.5038 25.1013 31.9999 24.6052 31.9999 23.9932V21.8669H0Z"
      fill="url(#paint5_linear_716_1810)"
    />
    <path
      d="M30.8915 23.6443H1.1084C0.496093 23.6443 0 23.1479 0 22.5359V8.38525C0 7.77319 0.496093 7.2771 1.1084 7.2771H30.8918C31.5038 7.2771 31.9999 7.77319 31.9999 8.38525V22.5359C31.9999 23.1479 31.5038 23.6443 30.8915 23.6443Z"
      fill="url(#paint6_linear_716_1810)"
    />
    <path
      d="M0 20.4094V22.5356C0 23.1477 0.496093 23.644 1.1084 23.644H30.8918C31.5038 23.644 31.9999 23.1477 31.9999 22.5356V20.4094H0Z"
      fill="url(#paint7_linear_716_1810)"
    />
    <path
      d="M30.8915 22.1867H1.1084C0.496093 22.1867 0 21.6906 0 21.0786V6.92798C0 6.31592 0.496093 5.81958 1.1084 5.81958H30.8918C31.5038 5.81958 31.9999 6.31567 31.9999 6.92798V21.0786C31.9999 21.6906 31.5038 22.1867 30.8915 22.1867Z"
      fill="url(#paint8_linear_716_1810)"
    />
    <path
      d="M0 18.9521V21.0786C0 21.6907 0.496093 22.1868 1.1084 22.1868H30.8918C31.5038 22.1868 31.9999 21.6907 31.9999 21.0786V18.9521H0Z"
      fill="url(#paint9_linear_716_1810)"
    />
    <path
      d="M30.8915 20.3672H1.1084C0.496093 20.3672 0 19.8711 0 19.259V5.1084C0 4.49634 0.496093 4 1.1084 4H30.8918C31.5038 4 31.9999 4.49634 31.9999 5.1084V19.259C31.9999 19.8711 31.5038 20.3672 30.8915 20.3672Z"
      fill="url(#paint10_linear_716_1810)"
    />
    <path
      d="M0 17.1328V19.259C0 19.8711 0.496093 20.3672 1.1084 20.3672H30.8918C31.5038 20.3672 31.9999 19.8711 31.9999 19.259V17.1328H0Z"
      fill="url(#paint11_linear_716_1810)"
    />
    <path
      d="M30.4924 7.23486C29.5188 7.23486 28.7297 6.43726 28.7297 5.45337C28.7297 5.45215 28.7297 5.45117 28.7297 5.44995C28.73 5.26123 28.5828 5.10596 28.3943 5.10596H3.60376C3.41528 5.10596 3.26807 5.26123 3.26831 5.44995V5.45337C3.26831 6.43726 2.47925 7.23486 1.50562 7.23486C1.49316 7.23486 1.48047 7.23486 1.46802 7.23462C1.27979 7.23047 1.125 7.38135 1.125 7.56958V16.7976C1.125 16.9858 1.27979 17.1367 1.46802 17.1326C1.48047 17.1323 1.49316 17.1323 1.50562 17.1323C2.47925 17.1323 3.26831 17.9299 3.26831 18.9138V18.9172C3.26807 19.106 3.41528 19.2612 3.60376 19.2612H28.3943C28.5828 19.2612 28.73 19.106 28.7297 18.9172C28.7297 18.916 28.7297 18.915 28.7297 18.9138C28.7297 17.9299 29.5188 17.1323 30.4924 17.1323C30.5049 17.1323 30.5176 17.1323 30.53 17.1326C30.7183 17.1367 30.873 16.9858 30.873 16.7976V7.56958C30.873 7.38135 30.7183 7.23047 30.53 7.23462C30.5173 7.23486 30.5049 7.23486 30.4924 7.23486Z"
      fill="url(#paint12_linear_716_1810)"
    />
    <path
      d="M31.0205 20.3594L18.8965 8.23535C18.8042 8.06104 18.6023 7.91772 18.2896 7.80518C17.9839 7.69556 17.6582 7.62012 17.3135 7.57788C17.2981 7.56152 17.28 7.5459 17.2595 7.53052C17.2114 7.49536 17.1611 7.47168 17.1089 7.45703C17.1062 7.38257 17.0657 7.31616 16.9866 7.25781C16.9387 7.22266 16.8884 7.19897 16.8359 7.18433C16.8335 7.10986 16.793 7.04346 16.7139 6.98511C16.6318 6.92505 16.5437 6.89478 16.449 6.89478C16.4473 6.89478 15.8909 6.89478 15.8892 6.89478C15.8374 6.89478 15.7896 6.90234 15.7454 6.91748C15.7012 6.93237 15.6609 6.95508 15.6243 6.98511C15.5693 7.03027 15.5352 7.08032 15.5215 7.13525C15.5168 7.15356 15.5146 7.17236 15.5146 7.19165V7.56641C15.0786 7.61475 14.6873 7.72363 14.3406 7.89331C14.1323 7.99487 13.9404 8.11841 13.7644 8.26367C13.2952 8.65112 13.0605 9.21899 13.0605 9.96704C13.0605 10.2334 13.0906 10.4763 13.1509 10.6953C13.2112 10.9146 13.3103 11.1057 13.448 11.2688C13.5168 11.3506 13.584 11.4263 13.6499 11.4961C13.6499 11.4961 15.5 13.343 15.5107 13.3523C15.512 13.3538 15.5134 13.3552 15.5146 13.3567V15.4221C15.3547 15.3735 15.2053 15.3081 15.0664 15.2258C14.7756 15.0542 14.5474 14.8931 14.3811 14.7427C14.2148 14.5923 14.0808 14.5171 13.9785 14.5171C13.9763 14.5171 13.4202 14.5171 13.4185 14.5171C13.303 14.5171 13.197 14.563 13.1008 14.6548C13.0686 14.6855 13.0376 14.7212 13.0078 14.762C12.8879 14.9253 12.8281 15.0886 12.8281 15.2517C12.8281 15.2734 12.8291 15.2952 12.8311 15.3169C12.8435 15.4468 12.8921 15.5759 12.9775 15.7039C12.9998 15.7371 13.0251 15.77 13.052 15.803C13.0774 15.8337 13.1038 15.8645 13.1333 15.8953L17.6108 20.3674H30.8931C30.936 20.3672 30.9785 20.3643 31.0205 20.3594Z"
      fill="url(#paint13_linear_716_1810)"
    />
    <path
      d="M16.4492 17.4727C16.5437 17.4727 16.6321 17.4429 16.7139 17.3838C16.7957 17.3245 16.8367 17.2568 16.8367 17.1809V16.7495C17.5559 16.6458 18.1252 16.3669 18.5449 15.9133C18.9646 15.4597 19.1743 14.8481 19.1743 14.0789C19.1743 13.658 19.1101 13.2903 18.9817 12.9768C18.8533 12.6631 18.6628 12.4033 18.4102 12.197C18.1575 11.9907 17.9175 11.8296 17.6907 11.7136C17.4641 11.5977 17.1792 11.4751 16.8367 11.3462V8.82837C16.98 8.86938 17.1199 8.92236 17.2561 8.98706C17.5645 9.13354 17.7532 9.20654 17.8218 9.20654H18.3818C18.5554 9.20654 18.6943 9.12256 18.7986 8.95459C18.9026 8.78662 18.9548 8.62524 18.9548 8.47021C18.9548 8.18604 18.7332 7.9646 18.2898 7.80518C17.8462 7.646 17.3618 7.55762 16.8367 7.54028V7.19165C16.8367 7.11401 16.7957 7.04517 16.7139 6.98486C16.6321 6.9248 16.5439 6.89453 16.4492 6.89453C16.4473 6.89453 15.8911 6.89453 15.8892 6.89453C15.7859 6.89453 15.6975 6.9248 15.6245 6.98486C15.5513 7.04541 15.5146 7.11401 15.5146 7.19165V7.56616C14.8171 7.64355 14.2336 7.87622 13.7646 8.26367C13.2952 8.65112 13.0605 9.21899 13.0605 9.9668C13.0605 10.2332 13.0906 10.4761 13.1511 10.6951C13.2112 10.9143 13.3103 11.1055 13.4482 11.2686C13.5857 11.4319 13.717 11.5715 13.842 11.6877C13.9668 11.8037 14.1433 11.9155 14.3716 12.0227C14.5996 12.1301 14.7827 12.2119 14.9204 12.2676C15.0581 12.3235 15.2563 12.3989 15.5146 12.4932V15.4221C15.3547 15.3733 15.2053 15.3079 15.0664 15.2258C14.7756 15.054 14.5474 14.8931 14.3811 14.7424C14.2148 14.592 14.0808 14.5168 13.9785 14.5168C13.9763 14.5168 13.4202 14.5168 13.4185 14.5168C13.2644 14.5168 13.1274 14.5984 13.0076 14.7617C12.8877 14.925 12.8281 15.0884 12.8281 15.2515C12.8281 15.5989 13.0884 15.9395 13.6094 16.2737C14.1304 16.6079 14.7654 16.7793 15.5146 16.7878V17.1809C15.5146 17.2568 15.551 17.3245 15.6243 17.3838C15.6975 17.4429 15.7859 17.4724 15.8892 17.4724C15.8909 17.4727 16.4473 17.4727 16.4492 17.4727ZM16.759 13.0864C16.8655 13.1631 16.9587 13.2449 17.0386 13.3313C17.2366 13.5461 17.3357 13.8425 17.3357 14.2205C17.3357 14.7285 17.1433 15.0903 16.759 15.3062V13.0864ZM15.592 10.855C15.4407 10.7742 15.3142 10.6909 15.2124 10.605C15.0037 10.4292 14.8992 10.1733 14.8992 9.83813C14.8992 9.3772 15.1304 9.05933 15.592 8.88379V10.855Z"
      fill="url(#paint14_linear_716_1810)"
    />
    <path
      d="M12.8281 15.2517C12.8281 15.0884 12.8879 14.9253 13.0078 14.762C13.1274 14.5986 13.2644 14.5171 13.4187 14.5171C13.5208 14.5171 13.655 14.5923 13.8213 14.7427C13.9875 14.8931 14.2158 15.0542 14.5063 15.2258C14.7969 15.3979 15.1331 15.4966 15.5146 15.5225V12.4934C15.2563 12.3989 15.0581 12.3237 14.9204 12.2678C14.7827 12.2122 14.5996 12.1304 14.3716 12.0229C14.1433 11.9155 13.9668 11.8037 13.842 11.6877C13.7173 11.5718 13.5857 11.4321 13.4482 11.2688C13.3103 11.1057 13.2112 10.9146 13.1511 10.6953C13.0906 10.4761 13.0605 10.2334 13.0605 9.96704C13.0605 9.21899 13.2952 8.65112 13.7646 8.26367C14.2336 7.87622 14.8171 7.6438 15.5146 7.56641V7.19165C15.5146 7.11426 15.5513 7.04541 15.6245 6.98511C15.6975 6.92505 15.7859 6.89478 15.8892 6.89478C15.9839 6.89478 16.072 6.92505 16.1541 6.98511C16.2356 7.04541 16.2766 7.11426 16.2766 7.19165V7.54053C16.8018 7.55786 17.2861 7.646 17.7297 7.80518C18.1731 7.9646 18.3948 8.18628 18.3948 8.47046C18.3948 8.62549 18.3428 8.78687 18.2385 8.95483C18.1343 9.1228 17.9954 9.20679 17.8218 9.20679C17.7532 9.20679 17.5645 9.13354 17.2561 8.98706C16.9475 8.84082 16.6211 8.75464 16.2766 8.72876V11.3462C16.6191 11.4753 16.9041 11.5977 17.1309 11.7139C17.3577 11.8298 17.5977 11.991 17.8501 12.197C18.1028 12.4033 18.2935 12.6633 18.4216 12.9768C18.55 13.2905 18.6145 13.658 18.6145 14.0789C18.6145 14.8484 18.4045 15.4597 17.9849 15.9133C17.5652 16.3672 16.9958 16.6458 16.2766 16.7495V17.1809C16.2766 17.2571 16.2356 17.3247 16.1538 17.384C16.072 17.4431 15.9839 17.4729 15.8892 17.4729C15.7859 17.4729 15.6975 17.4431 15.6243 17.3843C15.551 17.325 15.5146 17.2573 15.5146 17.1812V16.7883C14.7654 16.7795 14.1304 16.6082 13.6096 16.2739C13.0884 15.9397 12.8281 15.5991 12.8281 15.2517ZM14.3391 9.83813C14.3391 10.1733 14.4436 10.4292 14.6523 10.605C14.8611 10.7812 15.1743 10.9468 15.592 11.1013V8.75317C14.7568 8.85669 14.3391 9.21826 14.3391 9.83813ZM16.1992 15.4966C16.9568 15.3591 17.3357 14.9338 17.3357 14.2205C17.3357 13.8425 17.2366 13.5461 17.0386 13.3313C16.8406 13.1167 16.5608 12.9316 16.1992 12.7769V15.4966Z"
      fill="url(#paint15_linear_716_1810)"
    />
    <path
      d="M7.86963 12.1836C7.86963 13.2629 6.99463 14.1379 5.91528 14.1379C4.83594 14.1379 3.96094 13.2629 3.96094 12.1836C3.96094 11.1045 4.83594 10.2295 5.91528 10.2295C6.99463 10.2295 7.86963 11.1045 7.86963 12.1836Z"
      fill="url(#paint16_linear_716_1810)"
    />
    <path
      d="M28.0415 12.1836C28.0415 13.2629 27.1665 14.1379 26.0872 14.1379C25.0078 14.1379 24.1328 13.2629 24.1328 12.1836C24.1328 11.1045 25.0078 10.2295 26.0872 10.2295C27.1665 10.2295 28.0415 11.1045 28.0415 12.1836Z"
      fill="url(#paint17_linear_716_1810)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_716_1810"
        x1="0"
        y1="19.8328"
        x2="32"
        y2="19.8328"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_716_1810"
        x1="16"
        y1="26.3031"
        x2="16"
        y2="27.8645"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC9A0" stopOpacity="0" />
        <stop offset="0.0351" stopColor="#38C69D" stopOpacity="0.035294" />
        <stop offset="0.4167" stopColor="#23AA82" stopOpacity="0.415686" />
        <stop offset="0.7511" stopColor="#169971" stopOpacity="0.752941" />
        <stop offset="1" stopColor="#11936B" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_716_1810"
        x1="0"
        y1="18.3754"
        x2="32"
        y2="18.3754"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_716_1810"
        x1="16"
        y1="24.8452"
        x2="16"
        y2="26.4066"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC9A0" stopOpacity="0" />
        <stop offset="0.0351" stopColor="#38C69D" stopOpacity="0.035294" />
        <stop offset="0.4167" stopColor="#23AA82" stopOpacity="0.415686" />
        <stop offset="0.7511" stopColor="#169971" stopOpacity="0.752941" />
        <stop offset="1" stopColor="#11936B" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_716_1810"
        x1="0"
        y1="16.918"
        x2="32"
        y2="16.918"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_716_1810"
        x1="16"
        y1="23.3878"
        x2="16"
        y2="24.9492"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC9A0" stopOpacity="0" />
        <stop offset="0.0351" stopColor="#38C69D" stopOpacity="0.035294" />
        <stop offset="0.4167" stopColor="#23AA82" stopOpacity="0.415686" />
        <stop offset="0.7511" stopColor="#169971" stopOpacity="0.752941" />
        <stop offset="1" stopColor="#11936B" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_716_1810"
        x1="0"
        y1="15.4606"
        x2="32"
        y2="15.4606"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_716_1810"
        x1="16"
        y1="21.9304"
        x2="16"
        y2="23.4918"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC9A0" stopOpacity="0" />
        <stop offset="0.0351" stopColor="#38C69D" stopOpacity="0.035294" />
        <stop offset="0.4167" stopColor="#23AA82" stopOpacity="0.415686" />
        <stop offset="0.7511" stopColor="#169971" stopOpacity="0.752941" />
        <stop offset="1" stopColor="#11936B" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_716_1810"
        x1="0"
        y1="14.0032"
        x2="32"
        y2="14.0032"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_716_1810"
        x1="16"
        y1="20.4732"
        x2="16"
        y2="22.0346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC9A0" stopOpacity="0" />
        <stop offset="0.0351" stopColor="#38C69D" stopOpacity="0.035294" />
        <stop offset="0.4167" stopColor="#23AA82" stopOpacity="0.415686" />
        <stop offset="0.7511" stopColor="#169971" stopOpacity="0.752941" />
        <stop offset="1" stopColor="#11936B" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_716_1810"
        x1="0"
        y1="12.1836"
        x2="32"
        y2="12.1836"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_716_1810"
        x1="16"
        y1="18.6537"
        x2="16"
        y2="20.2151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3AC9A0" stopOpacity="0" />
        <stop offset="0.0351" stopColor="#38C69D" stopOpacity="0.035294" />
        <stop offset="0.4167" stopColor="#23AA82" stopOpacity="0.415686" />
        <stop offset="0.7511" stopColor="#169971" stopOpacity="0.752941" />
        <stop offset="1" stopColor="#11936B" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_716_1810"
        x1="14.6271"
        y1="9.56738"
        x2="23.1728"
        y2="25.8639"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#445EA0" />
        <stop offset="0.3216" stopColor="#415A9B" />
        <stop offset="0.6926" stopColor="#364D8D" />
        <stop offset="1" stopColor="#2A3D7C" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_716_1810"
        x1="23.8117"
        y1="15.4993"
        x2="12.6382"
        y2="12.4078"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2A3D7C" stopOpacity="0" />
        <stop offset="0.3949" stopColor="#273A77" stopOpacity="0.396078" />
        <stop offset="0.8504" stopColor="#1E3069" stopOpacity="0.85098" />
        <stop offset="1" stopColor="#1A2B63" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_716_1810"
        x1="24.6829"
        y1="12.1837"
        x2="17.9974"
        y2="12.1837"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD00D" />
        <stop offset="0.2378" stopColor="#FFCB0E" />
        <stop offset="0.5353" stopColor="#FFBB11" />
        <stop offset="0.8632" stopColor="#FFA215" />
        <stop offset="1" stopColor="#FF9517" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_716_1810"
        x1="12.5433"
        y1="12.1837"
        x2="20.0071"
        y2="12.1837"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD00D" />
        <stop offset="0.2378" stopColor="#FFCB0E" />
        <stop offset="0.5353" stopColor="#FFBB11" />
        <stop offset="0.8632" stopColor="#FFA215" />
        <stop offset="1" stopColor="#FF9517" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_716_1810"
        x1="5.69296"
        y1="11.7597"
        x2="7.07774"
        y2="14.4004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_716_1810"
        x1="25.8649"
        y1="11.7597"
        x2="27.2496"
        y2="14.4004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00E7B2" />
        <stop offset="0.2459" stopColor="#05E5B1" />
        <stop offset="0.5301" stopColor="#13DDAC" />
        <stop offset="0.8322" stopColor="#2AD1A5" />
        <stop offset="1" stopColor="#3AC9A0" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconPriceRange;
